/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function CookingPot(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M88,48V16a8,8,0,0,1,16,0V48a8,8,0,0,1-16,0Zm40,8a8.00039,8.00039,0,0,0,8-8V16a8,8,0,0,0-16,0V48A8.00039,8.00039,0,0,0,128,56Zm32,0a8.00039,8.00039,0,0,0,8-8V16a8,8,0,0,0-16,0V48A8.00039,8.00039,0,0,0,160,56Zm94.3999,35.2002a7.99886,7.99886,0,0,0-11.1997-1.6001L224,104V88a16.01833,16.01833,0,0,0-16-16H48A16.01833,16.01833,0,0,0,32,88v16L12.7998,89.6001a7.9998,7.9998,0,0,0-9.5996,12.7998L32,124v60a32.03667,32.03667,0,0,0,32,32H192a32.03667,32.03667,0,0,0,32-32V124l28.7998-21.6001A7.9993,7.9993,0,0,0,254.3999,91.2002Z" />
    </Svg>
  );
}

export default CookingPot;
